[
  {
    "code": "AG-10",
    "name": "Barbuda"
  },
  {
    "code": "AG-11",
    "name": "Redonda"
  },
  {
    "code": "AG-03",
    "name": "Saint George"
  },
  {
    "code": "AG-04",
    "name": "Saint John’s"
  },
  {
    "code": "AG-05",
    "name": "Saint Mary"
  },
  {
    "code": "AG-06",
    "name": "Saint Paul"
  },
  {
    "code": "AG-07",
    "name": "Saint Peter"
  },
  {
    "code": "AG-08",
    "name": "Saint Philip"
  }
]